export const isTextNode = (node) => node && node.text && !node.type;
export const isElementNode = (node) => node && node.type;
